const initialState = {
    field_type: 'ouders_2',
    field_color: 'stedelijk',
    field_where: 'Op de fiets naar school?',
    fontRatio: 0.635,
}

export default function Poster(state = initialState, action) {
    switch (action.type) {
        case 'SET_VALUE':
            return {
                ...state,
                [action.payload.type]: action.payload.value
            }

        default:
            return state
    }
}